import React, { useEffect, useRef } from "react";
import "./Logistics.css";
import logo from "../../assets/WHL-LOGO.png";
import axiosInstance from "../../services/auth";
import { toast, ToastContainer } from "react-toastify";
import { useReactToPrint } from "react-to-print";
import { useCombinedContext } from "../../context/CombinedContext";

const StockOutView = ({
  stockout,
  isViewMode,
  setIsViewMode,
  companyId,
  onUpdate,
}) => {
  // console.log("stockout data for view report", stockout);
  const { selectedCompany } = useCombinedContext();
  const company = selectedCompany;

  // Ref for printing
  const printRef = useRef(null);
  const handlePrint = useReactToPrint({
    content: () => printRef.current,
  });

  // Prevent background scrolling when modal is open
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  // Close modal when clicking outside.
  const handleOutsideClick = (e) => {
    if (e.target.classList.contains("modal")) {
      setIsViewMode(false);
    }
  };

  return (
    isViewMode && (
      <>
        <div
          className={`modal fade ${isViewMode ? "show d-block" : ""}`}
          style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)" }}
          tabIndex="-1"
          role="dialog"
          aria-hidden={!isViewMode}
          onClick={handleOutsideClick}
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content stockout_model">
              <div className="modal-header text-white text-center vesel_form">
                <h5 className="modal-title">Stockout Details</h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={() => setIsViewMode(false)}
                ></button>
              </div>
              <div ref={printRef} className="modal-body modalWhite">
                {/* Header Section with Company Info */}
                <div className="food_head" style={{ marginBottom: "25px" }}>
                  <div style={{ flex: "0 0 auto" }}>
                    <img
                      src={logo}
                      alt="logo"
                      style={{
                        width: "125px",
                        height: "auto",
                        paddingRight: "20px",
                      }}
                    />
                  </div>
                  <div
                    style={{ textAlign: "left", flex: "1", padding: "0 5px" }}
                  >
                    <h2
                      className="company_font"
                      style={{ margin: 0, textDecoration: "underline" }}
                    >
                      {company.company_name}
                    </h2>
                    <p style={{ margin: 0, fontSize: "12px" }}>
                      {`Co Reg No: ${company.co_regno} GST No: ${company.gst_no}`}
                      <br />
                      {company.address}
                      <br />
                      {`Tel: ${company.telephone} Fax: ${company.fax}`}
                      <br />
                      {company.email}
                    </p>
                  </div>
                </div>
                <hr />
                {/* Stockout Details */}
                <div>
                  <p className="mt-3">
                    <strong>Employee Name:</strong> {stockout.employeeId?.name}
                  </p>
                  <p className="mt-3">
                    <strong>Employee No:</strong>{" "}
                    {stockout.employeeId?.employeeNo}
                  </p>
                  <p>
                    <strong>Location:</strong>{" "}
                    {[
                      stockout.locationId?.code,
                      stockout.locationId?.yard_name,
                      stockout.locationId?.address,
                      stockout.locationId?.country,
                      stockout.locationId?.pincode,
                    ]
                      .filter(Boolean)
                      .join(", ")}
                  </p>

                  <p>
                    <strong>Date:</strong>{" "}
                    {stockout.date
                      ? new Date(stockout.date).toLocaleDateString()
                      : "N/A"}
                  </p>
                  <div className="d-flex align-items-center justify-content-between mb-3">
                    <h6>Material Details:</h6>
                  </div>
                  {stockout?.stocks && stockout.stocks.length > 0 ? (
                    <table className="table">
                      <thead>
                        <tr>
                          <th>Sl No</th>
                          <th>Material Name</th>
                          <th>Description</th>
                          <th>Quantity</th>
                        </tr>
                      </thead>
                      <tbody>
                        {stockout.stocks.map((detail, index) => (
                          <tr key={detail._id}>
                            <td>{index + 1}</td>
                            <td>{detail.stock?.name || "N/A"}</td>
                            <td>{detail.stock?.description || "N/A"}</td>
                            <td>{detail.quantity || "N/A"}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : (
                    <p>No material details available.</p>
                  )}
                  <p>
                    <strong>Remarks:</strong> {stockout.remarks}
                  </p>
                </div>
              </div>
              <div className="text-center">
                <button className="button-2 mb-5" onClick={handlePrint}>
                  Print
                </button>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer />
      </>
    )
  );
};

export default StockOutView;
